export enum MagicLinkCreationResult {
  SUCCESS = "SUCCESS",
  NOT_FOUND = "NOT_FOUND",
  OTHER_ERROR = "OTHER_ERROR",
}
